<template>
  <router-view />
</template>

<script>
import bus from '@/bus'
import { call, get, sync } from 'vuex-pathify'

export default {
  name: 'App',
  data: () => {
    return {
      questionsConfigLoaded: false
    }
  },
  computed: {
    questionsConfig: get('questions/config'),
    activeStep: sync('questions/activeStep'),
    activeStepQuestion: get('questions/activeStepQuestion'),
    selection: sync('programs/selection'),
    getConditionalOptions: get('questions/getConditionalOptions'),
    findOptions() {
      return this.activeStepQuestion.optionGroups
        .filter((og) => {
          if (!og.condition) return
          return this.selection[og.condition.stepKey].includes(
            og.condition.required
          )
        })
        .map((og) => og.options)
        .flat()
    }
  },
  methods: {
    listPrograms: call('programs/list'),
    removeConditionalFields: call('programs/removeConditionalFields'),
    toggleSelect: call('programs/toggleSelect'),
    nextStep: call('questions/nextStep'),
    checkMoveToNextStep() {
      if (this.findOptions.length === 1) {
        const option = this.findOptions[0]
        this.toggleSelect({
          option,
          key: this.activeStepQuestion.key,
          multi: this.activeStepQuestion.multi
        })
        this.nextStep()
      }
    }
  },
  created() {
    bus.subscribe(this, 'questions/listed', () => {
      this.activeStep = this.questionsConfig.steps.slice(0, 1)[0]
    })
    bus.subscribe(this, 'questions/SET_CONFIG', () => {
      this.selection.site = this.questionsConfig.name
      if (!this.questionsConfigLoaded) {
        this.questionsConfigLoaded = true
        this.listPrograms(this.selection.site)
      }
    })
    bus.subscribe(this, 'questions/nextStepped', () => {
      this.checkMoveToNextStep()
    })
    bus.subscribe(this, 'questions/SET_ACTIVE_STEP', () => {
      // this.clearSelection()
      this.checkMoveToNextStep()
    })
    bus.subscribe(this, 'programs/removedSelection', ({ payload }) => {
      const options = this.getConditionalOptions
      let optionsToRemove
      if (options) {
        optionsToRemove = options.filter(
          (o) =>
            o.condition.stepKey === payload.key &&
            o.condition.required === payload.option.key
        )
      }
      if (optionsToRemove) {
        optionsToRemove.forEach((options) => {
          this.removeConditionalFields({
            key: options.selectionKey,
            values: options.options.map((o) => o.key)
          })
        })
      }
    })
  }
}
</script>
